import React, {ReactElement} from "react";

interface Props {
    window?: () => Window;
    children: ReactElement;
}

const EmptyLayout = (props: Props) => {
    return (
        <>
            {props.children}
        </>
    )
}

export default EmptyLayout
